export default "__VITE_ASSET__DsL$fwD6__"